import React from 'react';
import { Field } from 'react-final-form';

import FieldGroup from 'Shared/components/FormComponents/FieldGroup/FieldGroup';
import FormTextEditor from 'Shared/components/FormComponents/FormTextEditor';
import FormDateTimePicker from 'Shared/components/FormComponents/FormDateTimePicker';
import { required, requiredEditorText } from 'Shared/utils/formValidations';
import WpIcon from 'Wpds/components/icon/WpIcon';
import Colors from 'Wpds/colors/ColorConstants';

import OwnerField from './OwnerField/OwnerField';

function FormFields() {
  return (
    <>
      <FieldGroup label="Title" labelClassName="CreateFeedbackAIModal__label">
        <Field
          name="title"
          validate={requiredEditorText}
          errorLabel
          component={FormTextEditor}
          placeholder="Add Title"
        />
      </FieldGroup>

      <div className="d-flex w-100 mt-1 pb-3">
        <FieldGroup label="Due Date" labelClassName="CreateFeedbackAIModal__label" className="w-50 mr-4">
          <Field
            name="dueDate"
            component={FormDateTimePicker}
            inputClassName="CreateFeedbackAIModal__date-input"
            validate={required}
            placeholder="Choose date"
            dateFormat="ll"
            timeFormat={false}
            icon={<WpIcon name="calendar-plus" color={Colors.gray[600]} />}
          />
        </FieldGroup>

        <FieldGroup label="Owner" labelClassName="CreateFeedbackAIModal__label" className="w-75">
          <Field name="owner" component={OwnerField} />
        </FieldGroup>
      </div>
    </>
  );
}

export default FormFields;
